import React, { ReactElement } from 'react';

import { Button, AddIcon } from 'elmo-elements';
import { useDispatch, useSelector } from 'react-redux';

import { ElearningReviewersStateType } from '@/modules/types/elearningReviewers';
import { actions as ElearningReviewersActions } from '@/modules/reducers/elearningReviewers';

const AddReviewerButton = (): ReactElement => {
  const dispatch = useDispatch();

  const elearningReviewersState: ElearningReviewersStateType = useSelector(
    (state: { elearningReviewers: ElearningReviewersStateType }) =>
      state.elearningReviewers,
  );

  const handleAddReviewer = () => {
    dispatch({
      type: ElearningReviewersActions.openReviewerModal.type,
    });
  };

  return (
    <Button
      id="AddReviewerButton"
      type="default"
      icon={<AddIcon />}
      isUppercase={false}
      onClick={handleAddReviewer}
      isDisabled={elearningReviewersState.isReviewerModalOpen}
    >
      Add Reviewer
    </Button>
  );
};

export default AddReviewerButton;
